import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col, Space, Typography } from 'antd';

const { Text, Title } = Typography;

const bodyBase = {
  padding: '14px 18px',
  background: 'var(--primary-gradient)',
  color: 'white',
  borderRadius: 8,
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
};

function normalizeCount(count) {
  if (count === undefined || count === null || count === '') return undefined;

  const parsed = typeof count === 'number' ? count : Number(count);

  return Number.isFinite(parsed) ? parsed : undefined;
}

export default function StickyBar({
  title,
  prefixIcon: PrefixIcon,
  onPrefixClick,
  count,
  fields = [],
  actions,
  top = 83,
  style,
}) {
  const safeCount = normalizeCount(count);
  const safeFields = Array.isArray(fields) ? fields : [];

  const bodyStyle = { ...bodyBase, ...style };

  const cardStyle = {
    position: 'sticky',
    top,
    zIndex: 999,
    marginBottom: 16,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  };

  const prefixIconStyle = {
    fontSize: 18,
    cursor: onPrefixClick ? 'pointer' : 'default',
    color: 'white',
  };

  return (
    <Card size="small" style={cardStyle} styles={{ body: bodyStyle }}>
      <Row gutter={[16, 12]} align="top">
        <Col span={24}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 12,
            }}
          >
            {PrefixIcon && (
              <PrefixIcon
                onClick={onPrefixClick}
                style={prefixIconStyle}
              />
            )}

            {title && (
              <Title
                level={5}
                style={{
                  margin: 0,
                  color: 'white',
                  fontSize: '20px',
                  whiteSpace: 'nowrap',
                }}
              >
                {title}
                {safeCount !== undefined && (
                  <span style={{ marginLeft: 8, fontWeight: 'normal' }}>
                    ({safeCount})
                  </span>
                )}
              </Title>
            )}

            <Space size="middle" style={{ justifyContent: 'flex-end', width: '100%' }}>
              {actions}
            </Space>
          </div>
        </Col>

        <Col span={24}>
          <Space size="middle" wrap>
            {safeFields.map(({ key, label, value }, index) => (
              <Text
                key={key ?? label ?? index}
                style={{ fontSize: '16px', color: 'white' }}
              >
                {label && <strong>{label} : </strong>}
                {value ?? '—'}
              </Text>
            ))}
          </Space>
        </Col>
      </Row>
    </Card>
  );
}

StickyBar.propTypes = {
  title: PropTypes.node,
  prefixIcon: PropTypes.elementType,
  onPrefixClick: PropTypes.func,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      value: PropTypes.node,
    })
  ),
  actions: PropTypes.node,
  top: PropTypes.number,
  style: PropTypes.object,
};